import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
export interface RequestMsg {
    type: number;
    body: string;
    pendingId: number;
    requestId: string;
    clientId: string;
    vanRespone: string;
    printRespone: string;
    success : boolean;
}
@Injectable({ providedIn: 'root' })
export class WebSocketService {
    constructor(private http: HttpClient) { }
    ws: any = null;
    private pending = new Map();
    private connectionStatus$ = new BehaviorSubject<boolean>(false);
    status$ = this.connectionStatus$.asObservable();

    private heartbeatTimer: any;
    private lastPongTime = Date.now();
    private heartbeatInterval = 60000; // 60s

    private connectStatus = false;

    body = {
        request: {
            userId: 20,
            userName: 'admin',
            jsonParams: '',
            functionCode: 100,
            option: 1,
            commandType: 1,
            data: null,
            dataList: [],
        }
    };

    initWebSocket() {
        if (this.ws) {
            if (this.ws.readyState === WebSocket.OPEN) return;
        }

        this.ws = new WebSocket("ws://127.0.0.1:51234/ws/");

        this.ws.onopen = () => {
            this.connectionStatus$.next(true);
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
            }
            this.startHeartbeat();
        };

        this.ws.onmessage = (e: any) => {
            const data = JSON.parse(e.data);

            if (data.type === 5) {
                this.lastPongTime = Date.now();
                return;
            }

            if (this.pending.has(data.requestId)) {
                const { resolve } = this.pending.get(data.requestId);
                resolve(data);
                this.pending.delete(data.requestId);
            }
        };


        this.ws.onclose = () => {
            this.connectionStatus$.next(false);
            this.scheduleReconnect();
        };

        this.ws.onerror = () => {
            this.connectionStatus$.next(false);
            this.scheduleReconnect();
        };
    }

    private reconnectTimer: any = null;
    private scheduleReconnect() {
        if (this.connectStatus) {
            return;
        }
        if (this.reconnectTimer) {
            return;
        }
        this.reconnectTimer = setTimeout(() => {
            this.reconnectTimer = null;
            this.initWebSocket();

        }, this.heartbeatInterval);

    }

    private startHeartbeat() {
        if (this.heartbeatTimer) return;

        this.heartbeatTimer = setInterval(async () => {
            const param = {
                type: 5
            }
            await this.sendMessage(param);
            const now = Date.now();
            if (now - this.lastPongTime > 10000) {
                this.ws.close();
            }

        }, this.heartbeatInterval);
    }

    sendMessage(param: any, timeout = 30000): Promise<RequestMsg> {
        const requestId = Date.now().toString();

        const payload = {
            ...param,
            requestId
        };

        return new Promise<RequestMsg>(async (resolve, reject) => {
            if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
                reject("AGENTSTR0001");
            }
            this.pending.set(requestId, { resolve, reject });

            this.ws.send(JSON.stringify(payload));

            setTimeout(() => {
                if (this.pending.has(requestId)) {
                    this.pending.delete(requestId);
                    reject("AGENTSTR0001");
                }
            }, timeout);
        });
    }

    waitForOpen(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (!this.ws) {
                return reject("WS not initialized");
            }

            if (this.ws.readyState === WebSocket.OPEN) {
                return resolve();
            }

            let isDone = false;

            const check = setInterval(() => {
                if (this.ws.readyState === WebSocket.OPEN) {
                    if (!isDone) {
                        isDone = true;
                        clearInterval(check);
                        clearTimeout(timeout);
                        resolve();
                    }
                }
            }, 100);

            const timeout = setTimeout(() => {
                if (!isDone) {
                    isDone = true;
                    clearInterval(check);
                    reject("WS open timeout");
                }
            }, 5000);

            if (this.ws.readyState === WebSocket.CLOSED) {
                this.initWebSocket();
            }
        });
    }
}